import StoryblokClient, { ISbStoriesParams } from 'storyblok-js-client-6';
import { IPluginRefObject } from 'gatsby';
import config from '../../../gatsby-config';

export interface IProductMetadata {
  content: {
    catalog_number: string
    component: string
    name: string
    price: string
    underline: string
  };
}

export interface IProductMetadataError {
  response: string
  status: string
  message: string
}

export class CommerceService {
  public static readonly commerceApiRoot = process.env.GATSBY_COMMERCE_API_ROOT;

  public static readonly endpoints = {
    placeOrder: `${this.commerceApiRoot}/orders/place`,
  };

  /**
   * @param productId The storyblok uuid of the product metadata entry to fetch
   */
  public static async getProduct(
    productId: string,
  ): Promise<IProductMetadata | IProductMetadataError> {
    try {
      return this.storyblokClient
        .get(
          `cdn/stories/${productId}`,
          {
            version: this.storyblokVersion,
            find_by: 'uuid',
          } as ISbStoriesParams,
        )
        .then((response) => response.data.story);
    } catch (error) {
      return error as IProductMetadataError;
    }
  }

  private static storyblokConfiguration = (
    (config.plugins as IPluginRefObject[])
      .find((item) => item.resolve === 'gatsby-source-graphql')
    || {} as IPluginRefObject
  )
    ?.options
    ?.headers as { Token: string, Version: 'published' | 'draft' };

  private static readonly storyblokToken = this.storyblokConfiguration.Token;

  private static readonly storyblokVersion = this.storyblokConfiguration.Version;

  private static storyblokClient = new StoryblokClient({
    accessToken: this.storyblokToken,
    cache: {
      type: 'none',
    },
    https: true,
  });
}
